import $ from 'jquery';
import Option from './option';

export default class DataProvider {
  constructor(field, remote, creation) {
    this.field = field;
    this.remote = remote;
    this.creation = creation;
    this.initOptions();
  }

  initOptions() {
    if (this.field) {
      this.options = Array.from(this.field.querySelectorAll('option'))
        .map(option => Option.fromElement(option))
        .filter(option => !!option);
    } else {
      this.options = [];
    }
  }

  getOption(value) {
    if (value instanceof Option) return value;
    return this.options.find(option => option.value === value);
  }

  filter(value, callback) {
    if (this.remote && value) {
      this.fetch(value, callback);
    } else {
      const options = this.options.filter(option => option.match(value));
      if (callback) callback(options);
    }
  }

  resetOptions() {
    this.initOptions();
  }

  fetch(value, callback) {
    if (!this.remote || !this.remote.url) return;

    $.ajax({
      url: this.remote.url,
      type: 'get',
      data: Object.assign({
        [this.remote.searchKey]: value,
      }, this.remote.params),
      dataType: 'json',
    }).done((result) => {
      const options = [];

      if (Array.isArray(result.options) && result.options.length > 0
        && Array.isArray(result.options[0]) && Array.isArray(result.options[0][1])) {
        result.options.forEach((group) => {
          if (Array.isArray(group) && group.length > 1 && Array.isArray(group[1])) {
            group[1].forEach(opt => options.push(Option.fromJSON(opt, group[0])));
          }
        });
      } else if ($.isPlainObject(result.options)) {
        Object.keys(result.options).forEach((groupName) => {
          result.options[groupName]
            .forEach(opt => options.push(Option.fromJSON(opt, groupName)));
        });
      } else if (Array.isArray(result.options)) {
        result.options.forEach(opt => options.push(Option.fromJSON(opt)));
      }

      if (callback) callback(options, result.totalItemCount);
    });
  }

  create(value, callback) {
    if (!this.creation || !this.creation.url) return;
    const that = this;

    $.ajax({
      url: this.creation.url,
      type: this.creation.type || 'post',
      data: Object.assign({
        [this.creation.key]: value,
      }, this.creation.params),
      dataType: 'json',
    }).done((result) => {
      const option = Option.fromJSON(result.option);
      that.options = [option].concat(that.options);
      if (callback) callback(option, that.options);
    });
  }
}
